// extracted by mini-css-extract-plugin
module.exports = {"Role__label__3PO_2":"Role__label__3PO_2","Role__removable-user__1TVYh":"Role__removable-user__1TVYh","Role__role-description__3oWud":"Role__role-description__3oWud"};